export default "__VITE_ASSET__NO8o8uoA__"